
import {WOW} from '../../../node_modules/wowjs/dist/wow';
new WOW({
  offset: 100,
}).init();


$('.search-form .select .input').on('click',function(){
  $('.search-form .select').removeClass('active')
  $(this).closest('.select').addClass('active')
})
// $('.search-form .select .select-list ul').on('click','li',function(){
//   let $parents = $(this).closest('.select')
//   let id = $(this).data('id')
//   let text = $(this).data('text') ? $(this).data('text') : ''
//   let input = $parents.find('.input input')
//   if(input[0]){ $(input[0]).val(text) }
//   if(input[1]){ $(input[1]).val(id) }
//   $parents.removeClass('active')
// })

$('body').on('click',function(e){
  if($(e.target).parents('.search-form .select').length == 0){
    $('.search-form .select').removeClass('active')
  }
})